import { createAsyncThunk } from '@reduxjs/toolkit'
import GameMarketingResource from './game-marketing-resource-model'
import {
  delete_gameMarketingResource,
  load_gameMarketingResources,
  store_gameMarketingResource,
} from './gameMarketingResource-service'

export const LoadGameMarketingResourcesAsync = createAsyncThunk<any, any>(
  'composer/load/gameMarketingResource',
  async (params: { uid: string }) => {
    return await load_gameMarketingResources(params)
  },
)

export const CreateGameMarketingResourceAsync = createAsyncThunk<any, any>(
  'composer/create/gameMarketingResource',
  async (params: GameMarketingResource) => {
    return await store_gameMarketingResource(params)
  },
)

export const DeleteGameMarketingResourceAsync = createAsyncThunk<any, any>(
  'composer/delete/gameMarketingResource',
  async (params) => {
    return await delete_gameMarketingResource(params)
  },
)
